import React, { Component } from 'react'
import { connect } from 'react-redux'
import AppBar from '@mui/material/AppBar'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Paper from '@mui/material/Paper'
import Preferences from './perferences'
import Default from './default'
import Branding from './branding'
import EmailGatway from './emailGatway'
import SmsGateway from './smsGateway'
import HistoryDays from './HistoryDays'
import Wasl from './wasl'
import Account from './account'
import Style from 'style-it'
import withTranslationWrapper from '../../HOC/HocTranslate'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { withStyles } from '@mui/styles'
import Breadcrumb from '../common/Breadcrumb'
import Button from '../common/Button'
import { notifyError, notifySuccess } from '../../Utils/CustomNotifcations'
import Loader from '../../Layout/Loader'

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  paper: {
    position: 'relative',
    padding: theme.spacing(1) * 2,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1) * 2
  },
  nested: {
    paddingLeft: theme.spacing(1) * 4
  }
})

class serverSettings extends Component {
  constructor () {
    super()
    this.state = {
      value: 0,
      serverSetting: '',
      serverPrefernceSetting: '',
      AccountSettings:'',
      loader:true,
    }
  }
  componentWillMount () {
    if(!this.props.updateOtherServerSetting){
      this.setState({value:'settings'})
    }
    if (this.props.logInUser.userType === -1) {
      // server call
      fetch(`/api/server/`, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then(response => {
          if (response.ok) {
            response.json().then(server => {
              if(server.status ==='success'){
                this.setState({
                  serverPrefernceSetting: server.data
                })
              }
              else if(server?.statusCode === '440'){
                window.location.replace('/login')
              }
              else if(server.statusCode){
                var err = server?.message.split(':')
                err[1] =err[1].replace(')', "")
                this.props.dispatch(
                  notifyError(err[1])
                )
              }
            })
          } else {
            throw response
          }
        })
        .catch(e => {
          console.log('e =',e)
          // this.props.dispatch(notifyError({
          //   message: 'somethingWentWrong',
          //   autoDismiss: 5
          // }))
        })
    }
    this.setAccountSettings(this.props.ServerSetting)
  }

  componentWillReceiveProps (n){
    if(n?.ServerSetting?.id !== this.props?.ServerSetting?.id){
        this.setAccountSettings(n.ServerSetting)
      }
  }

  setAccountSettings = (item)=>{
    if(item){
      this.setState({AccountSettings:item, loader:false})
    }

  }

  handleChange = (event, value) => {
    this.setState({ value })
  }
  handleChangeServerSettings =(item)=>{
    this.setState({serverPrefernceSetting:item})
  }
  handleChangeAccounts =(item)=>{
    this.setState({AccountSettings:item, loader:false})
  }
  render () {
    const { classes, logInUser } = this.props
    const { value, serverSetting, serverPrefernceSetting } = this.state
    const orientation = window.innerWidth <= 959 ? 'horizontal' : 'vertical'
    let tabName = 'Edit'
    // if(value ===0){tabName='Account Settings'}
    // else if(value===1){tabName='Branding'}
    // else if(value===2){tabName='Preferences'}
    // else if(value===3){tabName='Default'}
    // else if(value===4){tabName='Email Gateway'}
    // else if(value===5){tabName='Sms Gateway'}

    if(value ===0){tabName=this.props.translate('branding')}
    else if(value===1){tabName=this.props.translate('emailGateway')}
    else if(value===2){tabName=this.props.translate('smsGateway')}
    else if(value===3){tabName=this.props.translate('historyDays')}

    if (this.props.ServerSetting && !this.state.loader) {
      if (this.props.updateOtherServerSetting) {
        return (
          <div className={classes.root}>
            <Breadcrumb
              tabName={tabName}
              onClose={this.props.onClose}
              moduleName={this.props.translate('serverSettings')}
            />
           <Style>{`
          .tab-vertial-wrapper > .custom-tabs {
            background: ${this.props.themecolors.backgroundColor};
          }
          .custom-tab-button2 .MuiTab-wrapper {
            align-items: normal;
            flex-direction: row;
            justify-content: unset;

          }
          .custom-tab-button2 {
            color: ${this.props.themecolors.textColor};
            text-align: left;
            text-transform: inherit;
            border-bottom: 1px solid rgba(0,0,0,0.05)
          }
          .custom-tab-button {
            min-height: 29px;
            border-radius: 6px 6px 0 0;
            margin: 0 2px;
            background: ${this.props.themecolors['600']};
            color: ${this.props.themecolors['themeInverse']};
          }
          .custom-tabs {
            min-height: 30px;
            margin: 10px 6px 0;
          }

          .Mui-selected  {
            color: ${this.props.themecolors["500"]}  !important;
          }
          .custom-tab-button-selected2 {
            color: ${this.props.themecolors['500']};
          }`}</Style>
          <div className="v-tabs">
           <AppBar elevation={0} position="static" style={{background: 'transparent'}} className="tab-vertial-wrapper">
              <Tabs
                value={value}
                onChange={this.handleChange}
                orientation={orientation}
                classes={{ root: 'custom-tabs' }}
                TabIndicatorProps={{
                  style: { background: 'transparent' }
                }}
              >
                <Tab
                  classes={{
                    root: 'custom-tab-button2',
                    selected: 'custom-tab-button-selected2'
                  }}
                    style={{alignItems:"flex-start", }}
                  label={<div style={{ display: "flex", alignItems: "center" }}><KeyboardArrowRightIcon color='currentColor' />{this.props.translate('branding')}</div>}
                />
                <Tab
                  classes={{
                    root: 'custom-tab-button2',
                    selected: 'custom-tab-button-selected2'
                  }}
                    style={{alignItems:"flex-start", }}
                  label={<div style={{ display: "flex", alignItems: "center" }}><KeyboardArrowRightIcon color='currentColor' />{this.props.translate('emailGateway')}</div>}
                />
                <Tab
                classes={{
                  root: 'custom-tab-button2',
                  selected: 'custom-tab-button-selected2'
                }}
                  style={{alignItems:"flex-start", }}
                label={<div style={{ display: "flex", alignItems: "center" }}><KeyboardArrowRightIcon color='currentColor' />{this.props.translate('smsGateway')}</div>}
              />
                <Tab
                classes={{
                  root: 'custom-tab-button2',
                  selected: 'custom-tab-button-selected2'
                }}
                style={{alignItems:"flex-start", }}

                label={<div style={{ display: "flex", alignItems: "center" }}><KeyboardArrowRightIcon color='currentColor' />{this.props.translate('historyDays')}</div>}
              />
              </Tabs>
            
            <Paper style={{ padding: 16, minHeight: 270, flex: 1 }} square={true}>
              {value === 0 && (
                <div>
                  <Branding
                    {...this.props}
                    ServerSetting={
                      this.props.updateOtherServerSetting
                        ? this.props.otherServerSetting
                        : this.props.ServerSetting
                    }
                  />
                </div>
              )}
              {value === 1 && (
                <div>
                  <EmailGatway
                    {...this.props}
                    translate={this.props.translate}
                    ServerSetting={
                      this.props.updateOtherServerSetting
                        ? this.props.otherServerSetting
                        : this.props.ServerSetting
                    }
                  />
                </div>
              )}
              {value === 2 && (
                <div>
                  <SmsGateway
                    {...this.props}
                    translate={this.props.translate}
                    ServerSetting={
                      this.props.updateOtherServerSetting
                        ? this.props.otherServerSetting
                        : this.props.ServerSetting
                    }
                  />
                </div>
              )}
              {value === 3 && (
                <div>
                  <HistoryDays
                    {...this.props}
                    translate={this.props.translate}
                    ServerSetting={
                      this.props.updateOtherServerSetting
                        ? this.props.otherServerSetting
                        : this.props.ServerSetting
                    }
                  />
                </div>
              )}
            </Paper>
            </AppBar>
          </div>
          </div>
        )
      } else {
        if (this.props.logInUser.userType === -1) {
          if(value ==='settings'){tabName=this.props.translate('accountSettings')}
          else if(value==='branding'){tabName=this.props.translate('branding')}
          else if(value==='preferences'){tabName=this.props.translate('preferences')}
          else if(value==='default'){tabName=this.props.translate('default')}
          else if(value==='emailGateway'){tabName=this.props.translate('emailGateway')}
          else if(value==='smsGateway'){tabName=this.props.translate('smsGateway')}
          else if(value==='wasl'){tabName=this.props.translate('Wasl')}
          return (
            <div className={classes.root}>
               <Breadcrumb
                  tabName={tabName}
                  onClose={this.props.onClose}
                  moduleName={this.props.translate("serverSettings")}
                />
           <Style>{`
          .tab-vertial-wrapper > .custom-tabs {
            background: ${this.props.themecolors.backgroundColor};
          }
          .custom-tab-button2 .MuiTab-wrapper {
            align-items: normal;
            flex-direction: row;
            justify-content: unset;

          }
          .custom-tab-button2 {
            color: ${this.props.themecolors.textColor};
            text-align: left;
            text-transform: inherit;
            border-bottom: 1px solid rgba(0,0,0,0.05)
          }
          .custom-tab-button {
            min-height: 29px;
            border-radius: 6px 6px 0 0;
            margin: 0 2px;
            background: ${this.props.themecolors['600']};
            color: ${this.props.themecolors['themeInverse']};
          }
          .custom-tabs {
            min-height: 30px;
            margin: 10px 6px 0;
          }
 .Mui-selected  {
            color: ${this.props.themecolors["500"]}  !important;
          }
          .custom-tab-button-selected2 {
            color: ${this.props.themecolors['500']};
          }`}</Style>
            <div className="v-tabs">
            <AppBar elevation={0} position="static" style={{background: 'transparent'}} className="tab-vertial-wrapper">
                <Tabs
                  value={value}
                  onChange={this.handleChange}
                  orientation={orientation}
                  classes={{ root: 'custom-tabs' }}
                  TabIndicatorProps={{
                    style: { background: 'transparent' }
                  }}
                >
                    <Tab
                    classes={{
                      root: 'custom-tab-button2',
                      selected: 'custom-tab-button-selected2'
                    }}
                    style={{alignItems:"flex-start", }}
                    value="settings"
                    label={<div style={{ display: "flex", alignItems: "center" }}><KeyboardArrowRightIcon color='currentColor' />{this.props.translate('accountSetting')}</div>}
                  />
                  <Tab
                    classes={{
                      root: 'custom-tab-button2',
                      selected: 'custom-tab-button-selected2'
                    }}
                    style={{alignItems:"flex-start", }}
                    value="branding"
                    label={<div style={{ display: "flex", alignItems: "center" }}><KeyboardArrowRightIcon color='currentColor' />{this.props.translate('branding')}</div>}
                  />
                  <Tab
                    classes={{
                      root: 'custom-tab-button2',
                      selected: 'custom-tab-button-selected2'
                    }}
                    style={{alignItems:"flex-start", }}
                    value="preferences"
                    label={<div style={{ display: "flex", alignItems: "center" }}><KeyboardArrowRightIcon color='currentColor' />{this.props.translate('preferences')}</div>}
                  />
                  <Tab
                    classes={{
                        root: 'custom-tab-button2',
                        selected: 'custom-tab-button-selected2'
                      }}
                      style={{alignItems:"flex-start", }}
                      value="default"
                    label={<div style={{ display: "flex", alignItems: "center" }}><KeyboardArrowRightIcon color='currentColor' />{this.props.translate('default')}</div>}
                  />
                  <Tab
                    classes={{
                      root: 'custom-tab-button2',
                      selected: 'custom-tab-button-selected2'
                    }}
                    style={{alignItems:"flex-start", }}
                    value="emailGateway"
                    label={<div style={{ display: "flex", alignItems: "center" }}><KeyboardArrowRightIcon color='currentColor' />{this.props.translate('emailGateway')}</div>}
                  />
                  <Tab
                    classes={{
                      root: 'custom-tab-button2',
                      selected: 'custom-tab-button-selected2'
                    }}
                    style={{alignItems:"flex-start", }}
                    value="smsGateway"
                    label={<div style={{ display: "flex", alignItems: "center" }}><KeyboardArrowRightIcon color='currentColor' />{this.props.translate('smsGateway')}</div>}
                  />
                  <Tab
                    classes={{
                      root: 'custom-tab-button2',
                      selected: 'custom-tab-button-selected2'
                    }}
                    style={{alignItems:"flex-start", }}
                    value="wasl"
                    label={<div style={{ display: "flex", alignItems: "center" }}><KeyboardArrowRightIcon color='currentColor' />{this.props.translate('wasl')}</div>}
                  />
                </Tabs>
              {(
                <Paper style={{ padding: value === 'settings' ? 0 : 16, minHeight: 270, flex: 1 }} square={true}>
                  {value === 'settings' && (
                    <div>
                      <Account 
                        {...this.props}
                        handleChangeAccounts={this.handleChangeAccounts}
                        ServerSetting={this.state.AccountSettings}/>
                    </div>
                  )}
                  {value === 'branding' && (
                    <div>
                      <Branding {...this.props} />
                    </div>
                  )}
                  {value === 'preferences' && (
                    <div>
                      <Preferences
                        {...this.props}
                        ServerSetting={serverPrefernceSetting}
                        handleChangeServerSettings={this.handleChangeServerSettings}
                      />
                    </div>
                  )}
                  {value === 'default' && (
                    <div>
                      <Default 
                        {...this.props} 
                        ServerSetting={serverPrefernceSetting}
                        handleChangeServerSettings={this.handleChangeServerSettings}
                      />
                    </div>
                  )}
                  {value === 'emailGateway' && (
                    <div>
                      <EmailGatway
                        {...this.props}
                        translate={this.props.translate}
                        handleChangeServerSettings={this.handleChangeServerSettings}
                      />
                    </div>
                  )}
                  {value === 'smsGateway' && (
                    <div>
                      <SmsGateway
                        {...this.props}
                        translate={this.props.translate} />
                    </div>
                  )}
                  {value === 'wasl' && (
                    <div>
                      <Wasl
                        ServerSetting={
                          this.props.updateOtherServerSetting
                            ? this.props.otherServerSetting
                            : this.props.ServerSetting
                        }
                      />
                    </div>
                  )}
                </Paper>
              )}
               </AppBar>
            </div>
            </div>
          )
        } else {
          return (
            <div className={classes.root}>
               <Breadcrumb
                  tabName={tabName}
                  onClose={this.props.onClose}
                  moduleName={this.props.translate("serverSettings")}
              />
            <Style>{`
           .tab-vertial-wrapper > .custom-tabs {
             background: ${this.props.themecolors.backgroundColor};
           }
           .custom-tab-button2 .MuiTab-wrapper {
             align-items: normal;
             flex-direction: row;
             justify-content: unset;
 
           }
           .custom-tab-button2 {
             color: ${this.props.themecolors.textColor};
             text-align: left;
             text-transform: inherit;
             border-bottom: 1px solid rgba(0,0,0,0.05)
           }
           .custom-tab-button {
             min-height: 29px;
             border-radius: 6px 6px 0 0;
             margin: 0 2px;
             background: ${this.props.themecolors['600']};
             color: ${this.props.themecolors['themeInverse']};
           }
           .custom-tabs {
             min-height: 30px;
             margin: 10px 6px 0;
           }
 
           .custom-tab-button-selected2 {
             color: ${this.props.themecolors['500']};
           }`}</Style>
             <div className="v-tabs">
             <AppBar elevation={0} position="static" style={{background: 'transparent'}} className="tab-vertial-wrapper">
                 <Tabs
                   value={value}
                   onChange={this.handleChange}
                   orientation={orientation}
                   classes={{ root: 'custom-tabs' }}
                   TabIndicatorProps={{
                     style: { background: 'transparent' }
                   }}
                 >
                  <Tab
                    classes={{
                      root: 'custom-tab-button2',
                      selected: 'custom-tab-button-selected2'
                    }}
                    label={<><KeyboardArrowRightIcon color='currentColor' />{this.props.translate('Account Setting')}</>}
                  />
                  <Tab
                    classes={{
                      root: 'custom-tab-button2',
                      selected: 'custom-tab-button-selected2'
                    }}
                    label={<><KeyboardArrowRightIcon color='currentColor' />{this.props.translate('Branding')}</>}
                  />
                  <Tab
                    classes={{
                      root: 'custom-tab-button2',
                      selected: 'custom-tab-button-selected2'
                    }}
                    label={<><KeyboardArrowRightIcon color='currentColor' />{this.props.translate('emailGateway')}</>}
                  />
                </Tabs>
              
              <Paper style={{ padding: 16, minHeight: 270 , flex:1}} square={true}>
                {value === 0 && (
                  <div>
                    <Account {...this.props} readOnly={true} />
                  </div>
                )}
                {value === 1 && (
                  <div>
                    <Branding {...this.props} />
                  </div>
                )}
                {value === 2 && (
                  <div>
                    <EmailGatway
                      {...this.props}
                      translate={this.props.translate}
                    />
                  </div>
                )}
              </Paper>
              </AppBar>
            </div>
            </div>
          )
        }
      }
    } else {
      return <Loader defaultStyle/>
    }
  }
}


const mapState = state => {
  return {
    logInUser: state.logInUsers,
    themecolors: state.themecolors,
    users: state.users,
    accounts: state.accounts,
    roles: state.roles,
    ServerSetting: state.ServerSetting
  }
}

const mapStateToProps = connect(mapState)
export const Serversettings = mapStateToProps(
  withTranslationWrapper(withStyles(styles)(serverSettings))
)